define('nsecomm_websitecustomizations_main.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('nsecomm_websitecustomizations_main', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"main-info-card-content\"></span>";
},"useData":true}, 'extensions/NSeComm/WebsiteCustomizations/1.0.0/', 'extensions/NSeComm/WebsiteCustomizations/1.0.0/', Handlebars);
});